function checkReadOnly(readOnlyStatus, rowData, allowEdit = true) {
  if (!allowEdit) return true;
  if (!readOnlyStatus) return false;
  let readOnly = false;

  readOnlyStatus.map(condition => {
    const { key, status } = condition;
    let rowStatus = rowData[key];

    if (rowStatus !== null && status) {
      readOnly = status.some(value => {
        return rowStatus === value;
      });
    }
  });

  return readOnly;
}

export default checkReadOnly;
